export default {"src":"/_next/static/media/move-in.01b5c9c8.svg","height":656,"width":841};